/**
 * 設定路由, 把url路徑與 Vue Component 相配
 * 詳情請參閱 https://router.vuejs.org/
 */

//TODO: use path alias
import VueRouter from 'vue-router';
import Home from '@/Home';
import NotFound from '@/NotFound';
import SubCateList from '@/SubCateList';
import NswSearch from '@/NswSearch';
import ResourceList from '@/ResourceList';
import Terms from '@/Terms';
import ContactUs from '@/ContactUs';
import Disclaimer from '@/Disclaimer';
import ireaderResourcePage from '@/ireaderResourcePage/ireaderResourcePage'

//TODO: Handle 404 and 301
const router =  new VueRouter({
    mode: 'history',
    routes:[
        {
            path: '',
            redirect:'/home'
        },
        {
            path: '/',
            redirect:'/home'
        },
        {
            path: '/home',
            component: Home,
            name:'Home'
        },
        {
            path: '/resource/:cate_id/:subcate_id',
            component: SubCateList,
            name:'SubCateList'
        },
        {
            path: '/subject/:subject_id',  //TODO: to be removed. For testing subject route, we may use reg exp in real case
            component: Home,
            name:'subject'
        },
        {
            path: '*',
            component: NotFound,
            name:'NotFound'
        },
        {
            path: '/search',
            component: NswSearch,
            name:'NswSearch'
        },
        {
            path: '/resource_list/:subcate_id',
            component: ResourceList,
            name:'ResourceList'
        },
        {
            path: '/contact_us',
            component: ContactUs,
            name: 'ContactUs'
        },
        {
            path: '/terms',
            component: Terms,
            name: 'Terms'
        },
        {
            path: '/disclaimer',
            component: Disclaimer,
            name: 'Disclaimer'
        },
        {
            path: '/i_resource/:id',
            component: ireaderResourcePage,
            name: 'ireaderResourcePage'
        }
    ]
});

/**
 * Global route guard
 */
/*
router.beforeEach((to, from, next) => {


});
*/

export default router;



// WEBPACK FOOTER //
// ./resources/assets/js/routes.js